import A11yDialog from 'a11y-dialog';

$(document).ready(function () {
    $('.applyModalContainer').each(function () {
        var id = $(this).attr('id'); // Ensure your modalContainer element has a unique ID
        var container = document.getElementById(id);
        var dialog = new A11yDialog(container);

        // Add a show event listener
        dialog.on('show', function () {
            $('body').addClass('__modal');
            $('.applyModalContainer').attr('aria-hidden', 'false');
            $('.applyModalContainer').attr('tabindex', '0');
        });

        $('.applyNowTrigger').keypress(function() {
            $('.applyModalCloseButton').focus();
        })

        // Add a close button click handler
        $('.applyModalCloseButton').click(function () {
            $('body').removeClass('__modal');
            $('.applyModalContainer').attr('aria-hidden', 'true');
            $('.applyModalContainer').attr('tabindex', '-1');
            dialog.hide();
        });

        function shouldShowModalFromHash(hash) {
            return hash.startsWith('#gf');
        }

        // Detect hash change or URL reload
        if (shouldShowModalFromHash(window.location.hash)) {
            dialog.show();
            $('body').addClass('__modal');
            $('.applyModalContainer').attr('aria-hidden', 'false');
            $('.applyModalContainer').attr('tabindex', '0');
            $('.applyModalCloseButton').focus();
        }

        // Listen for hash changes dynamically
        window.addEventListener('hashchange', function () {
            if (shouldShowModalFromHash(window.location.hash)) {
                dialog.show();
                $('body').addClass('__modal');
                $('.applyModalContainer').attr('aria-hidden', 'false');
                $('.applyModalContainer').attr('tabindex', '0');
                $('.applyModalCloseButton').focus();
            }
        });
    });
});
